module.exports = __webpack_public_path__ + "img/img_works09.5738517c.jpg";